// Vẽ chấm đỏ / số lên favicon khi có tin nhắn mới (giống Facebook).
// Dùng canvas vẽ lại icon gốc + huy hiệu đỏ rồi gán vào <link rel="icon">.

const BASE_SRC = '/icon-32.png';
let baseImg = null; // ảnh icon gốc đã tải
let baseReady = false;
let lastCount = -1;

// Tải icon gốc 1 lần; khi xong, vẽ lại theo số badge mới nhất.
function loadBase() {
  if (baseImg) return;
  baseImg = new Image();
  baseImg.onload = () => { baseReady = true; if (lastCount > 0) draw(lastCount); };
  baseImg.onerror = () => { baseReady = false; };
  baseImg.src = BASE_SRC;
}

// Lấy (hoặc tạo) thẻ <link rel="icon"> động để cập nhật href.
function iconLink() {
  let link = document.querySelector("link[rel='icon'][data-dynamic]");
  if (!link) {
    // Ẩn các icon tĩnh để trình duyệt ưu tiên icon động.
    document.querySelectorAll("link[rel='icon']").forEach((l) => l.parentNode.removeChild(l));
    link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/png';
    link.setAttribute('data-dynamic', '1');
    document.head.appendChild(link);
  }
  return link;
}

function draw(count) {
  const size = 64;
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (baseReady) ctx.drawImage(baseImg, 0, 0, size, size);

  if (count > 0) {
    const label = count > 99 ? '99+' : String(count);
    const r = 20; // bán kính huy hiệu
    const cx = size - r - 2;
    const cy = r + 2;
    // Viền trắng cho nổi trên mọi nền tab.
    ctx.beginPath();
    ctx.arc(cx, cy, r + 3, 0, Math.PI * 2);
    ctx.fillStyle = '#fff';
    ctx.fill();
    // Chấm đỏ.
    ctx.beginPath();
    ctx.arc(cx, cy, r, 0, Math.PI * 2);
    ctx.fillStyle = '#e11d48';
    ctx.fill();
    // Số.
    ctx.fillStyle = '#fff';
    ctx.font = `bold ${label.length >= 3 ? 26 : 34}px -apple-system, Arial, sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(label, cx, cy + 1);
  }

  try { iconLink().href = canvas.toDataURL('image/png'); } catch { /* ignore */ }
}

// Cập nhật huy hiệu favicon theo số tin chưa đọc (0 = icon gốc, không badge).
export function setFaviconBadge(count) {
  const n = Number(count) || 0;
  if (n === lastCount) return;
  lastCount = n;
  loadBase();
  draw(n); // nếu ảnh gốc chưa tải xong, badge vẫn vẽ; onload sẽ vẽ lại kèm icon
}
